import React from "react";

import { Eyebrow, Title } from "../components/CommonComponents";
import MetaInfo from "../components/MetaInfo";
import Header from "../components/Header";
import Footer from "../components/Footer";
import iqacDirector from "../assets/img/IQAS/iqacDirector.jpg"

const iqacFiles = [
    { name: "1st Meeting MOM 2021_IQAC", file: require("../assets/img/IQAS/1st meeting MOM_IQAC .pdf") },
    { name: "1st Meeting_Circular_ IQAC", file: require("../assets/img/IQAS/1st meeting circular_ IQAC .pdf") },
    { name: "2nd Meeting MOM 2021_IQAC", file: require("../assets/img/IQAS/2nd meeting MOM_IQAC .pdf") },
    { name: "2nd Meeting_Circular_IQAC", file: require("../assets/img/IQAS/2nd meeting circular_IQAC .pdf") },
    { name: "3rd Meeting MOM 2022_IQAC", file: require("../assets/img/IQAS/3rd meeting MOM_IQAC .pdf") },
    { name: "3rd Meeting_Circular_IQAC", file: require("../assets/img/IQAS/3rd meeting circular_IQAC.pdf") },
    { name: "4th Meeting MOM 2022_IQAC", file: require("../assets/img/IQAS/4th meeting MOM_IQAC  (1).pdf") },
    { name: "4th Meeting_Circular_IQAC", file: require("../assets/img/IQAS/4th meeting circular_IQAC .pdf") },
    { name: "5th Meeting MOM 2022_IQAC", file: require("../assets/img/IQAS/4th meeting MOM_IQAC .pdf") },
    { name: "5th Meeting_Circular_IQAC", file: require("../assets/img/IQAS/5th meeting circular_IQAC .pdf") },
    { name: "6th Meeting MOM 2023-24_IQAC", file: require("../assets/img/IQAS/6th Meeting MOM 2023-24 -IQAC.pdf") },
    { name: "6th Meeting Circular_IQAC", file: require("../assets/img/IQAS/6th Meeting Circular-IQAC.pdf") },
    { name: "7th Meeting MOM 2024-25_IQAC", file: require("../assets/img/IQAS/7th Meeting MOM 2024-25-IQAC.pdf") },
    { name: "7th Meeting_Circular_IQAC", file: require("../assets/img/IQAS/7th Meeting  Circular -IQAC.pdf") },
];


const iqacMembers = [
    {
        name: "Dr. Anand Mahalwar",
        designation: "Chairperson",
        remarks: "Head of the Institution",
    },
    {
        name: "Dr. B.P. Bhol",
        designation: "Senior Administrative Officer",
        remarks: "Registrar",
    },
    {
        name: "Dr. Poonam Verma",
        designation: "Faculty Member",
        remarks: "Faculty Member",
    },
    {
        name: "Dr. Ashwani Sahu",
        designation: "Faculty Member",
        remarks: "Faculty Member",
    },
    {
        name: "Dr. Rajesh Kumar",
        designation: "Faculty Member",
        remarks: "Faculty Member",
    },
    {
        name: "Dr. Shameem Ahmed Khan",
        designation: "Teacher Member",
        remarks: "Faculty Member",
    },
    {
        name: "Dr. Abha Mahalwar",
        designation: "Teacher Member",
        remarks: "Faculty Member",
    },
    {
        name: "Dr. Ankit Mishra",
        designation: "Teacher Member",
        remarks: "Faculty Member",
    },
    {
        name: "Dr. Vimla Sona",
        designation: "Teacher Member",
        remarks: "Faculty Member",
    },
    {
        name: "Ms. Kesharlata Sahu",
        designation: "Teacher Member",
        remarks: "Faculty Member",
    },
    {
        name: "Mr. Yashwant Raj",
        designation: "Management Representative",
        remarks: "Management Representative",
    },
    {
        name: "Ms. Rekha Sahu",
        designation: "Nominee - Alumni",
        remarks: "Alumni",
    },
    {
        name: "Mr. Sunil Sahu",
        designation: "Nominee - Student",
        remarks: "Student Representative",
    },
    {
        name: "Mr. Roshan Dewangan",
        designation: "Nominee - Employer/Industrialist",
        remarks: "Industrialist",
    },
    {
        name: "Mr. Paras Ram Sahu",
        designation: "Nominee - Employer/Industrialist",
        remarks: "Industrialist",
    },
    {
        name: "Ms. Raveli Sahu",
        designation: "Nominee - Stakeholder",
        remarks: "Stakeholder",
    },
    {
        name: "Dr. N. Kumar Swamy",
        designation: "IQAC Coordinator",
        remarks: "Senior Teacher",
    },
];


const iqacMeetings = [
    {
        number: "01",
        meeting: "1st Meeting",
        year: "2021",
        mom: iqacFiles[0],
        circular: iqacFiles[1],
    },
    {
        number: "02",
        meeting: "2nd Meeting",
        year: "2021",
        mom: iqacFiles[2],
        circular: iqacFiles[3],
    },
    {
        number: "03",
        meeting: "3rd Meeting",
        year: "2022",
        mom: iqacFiles[4],
        circular: iqacFiles[5],
    },
    {
        number: "04",
        meeting: "4th Meeting",
        year: "2022",
        mom: iqacFiles[6],
        circular: iqacFiles[7],
    },
    {
        number: "05",
        meeting: "5th Meeting",
        year: "2022",
        mom: iqacFiles[8],
        circular: iqacFiles[9],
    },
    {
        number: "06",
        meeting: "6th Meeting",
        year: "2023–24",
        mom: iqacFiles[10],
        circular: iqacFiles[11],
    },
    {
        number: "07",
        meeting: "7th Meeting",
        year: "2024–25",
        mom: iqacFiles[12],
        circular: iqacFiles[13],
    },
];


function DocumentIcon() {
    return (
        <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5" aria-hidden="true">
            <path d="M7 3h7l4 4v14H7V3Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
            <path d="M14 3v5h4M9.5 12h5M9.5 16h5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
        </svg>
    );
}


function ArrowUpRight() {
    return (
        <svg viewBox="0 0 24 24" fill="none" className="h-4 w-4" aria-hidden="true">
            <path d="M7 17 17 7M9 7h8v8" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}


function QualityMark() {
    return (
        <svg viewBox="0 0 40 40" fill="none" className="h-10 w-10" aria-hidden="true">
            <circle cx="20" cy="20" r="14" stroke="currentColor" strokeWidth="1.4" />
            <circle cx="20" cy="20" r="7" stroke="currentColor" strokeWidth="1.4" />
            <path d="M20 3v6M20 31v6M3 20h6M31 20h6" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
            <circle cx="20" cy="20" r="2" fill="currentColor" />
        </svg>
    );
}


export default function IQAC() {
    return (
        <>
            <MetaInfo param="" id="about" />
            <Header school="common" />

            <main className="bg-white text-[#132337]">

                {/* UNIQUE IQAC HERO */}
                <section className="relative overflow-hidden bg-[#071A2F] pt-[100px] text-white">

                    {/* BACKGROUND */}
                    <div className="pointer-events-none absolute inset-0">

                        <div className="absolute inset-0 bg-[radial-gradient(circle_at_76%_48%,rgba(213,173,87,0.10),transparent_27%)]" />

                        <div className="absolute right-[4%] top-[110px] h-[510px] w-[510px] rounded-full border border-white/[0.05]" />

                        <div className="absolute right-[10%] top-[175px] h-[380px] w-[380px] rounded-full border border-[#D5AD57]/15" />

                        <div className="absolute right-[16%] top-[235px] h-[255px] w-[255px] rounded-full border border-white/[0.07]" />

                        <div className="absolute left-0 top-[100px] h-px w-full bg-white/[0.06]" />

                        <div className="absolute bottom-0 left-0 h-[5px] w-[30%] bg-[#8B1E3F]" />

                        <div className="absolute bottom-0 left-[30%] h-[5px] w-[15%] bg-[#D5AD57]" />

                    </div>


                    <div className="relative mx-auto grid min-h-[630px] w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)] lg:grid-cols-[1.06fr_.94fr]">

                        {/* LEFT CONTENT */}
                        <div className="flex flex-col justify-center py-16 pr-8 lg:py-20 lg:pr-20">

                            <div className="flex items-center gap-4 text-sm font-bold uppercase tracking-[0.18em] text-[#D5AD57]">

                                <span className="h-px w-12 bg-current" />

                                Internal Quality Assurance Cell

                            </div>


                            <h1 className="mt-7 max-w-[820px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(52px,6.2vw,90px)] font-normal leading-[0.95] tracking-[-0.045em]">

                                Quality that evolves.

                                <span className="block text-[#D5AD57]">
                                    Excellence that endures.
                                </span>

                            </h1>


                            <p className="mt-8 max-w-[700px] text-[17px] leading-8 text-white/65">

                                The Internal Quality Assurance Cell guides, monitors and strengthens quality assurance and quality enhancement across the academic activities of ISBM University.

                            </p>


                            <div className="mt-10 flex flex-wrap gap-x-8 gap-y-4 border-t border-white/15 pt-7">

                                {[
                                    "Quality Assurance",
                                    "Quality Enhancement",
                                    "Continuous Improvement",
                                    "Academic Excellence",
                                ].map((item) => (
                                    <div key={item} className="flex items-center gap-3">

                                        <span className="h-1.5 w-1.5 rotate-45 bg-[#D5AD57]" />

                                        <span className="text-[10px] font-bold uppercase tracking-[0.14em] text-white/60">
                                            {item}
                                        </span>

                                    </div>
                                ))}

                            </div>

                        </div>


                        {/* QUALITY COMPASS */}
                        <div className="relative hidden lg:flex lg:items-center lg:justify-center">

                            <div className="relative h-[470px] w-[470px]">

                                {/* OUTER RING */}
                                <div className="absolute inset-0 rounded-full border border-[#D5AD57]/20" />

                                <div className="absolute inset-[42px] rounded-full border border-white/10" />

                                <div className="absolute inset-[98px] rounded-full border border-[#D5AD57]/25" />


                                {/* CROSS LINES */}
                                <div className="absolute left-1/2 top-0 h-full w-px bg-white/[0.07]" />

                                <div className="absolute left-0 top-1/2 h-px w-full bg-white/[0.07]" />


                                {/* CENTER */}
                                <div className="absolute left-1/2 top-1/2 flex h-[180px] w-[180px] -translate-x-1/2 -translate-y-1/2 flex-col items-center justify-center rounded-full bg-[#D5AD57] text-[#071A2F] shadow-[0_20px_70px_rgba(0,0,0,.2)]">

                                    <QualityMark />

                                    <strong className="mt-3 font-['Libre_Caslon_Display',Georgia,serif] text-[42px] font-normal leading-none">
                                        IQAC
                                    </strong>

                                    <span className="mt-2 text-[8px] font-bold uppercase tracking-[0.17em]">
                                        Quality Cell
                                    </span>

                                </div>


                                {/* POINT 1 */}
                                <div className="absolute left-1/2 top-4 -translate-x-1/2 text-center">

                                    <span className="text-[9px] font-bold uppercase tracking-[0.15em] text-[#D5AD57]">
                                        Plan
                                    </span>

                                    <p className="mt-1 text-xs text-white/45">
                                        Quality Systems
                                    </p>

                                </div>


                                {/* POINT 2 */}
                                <div className="absolute right-2 top-1/2 -translate-y-1/2 text-right">

                                    <span className="text-[9px] font-bold uppercase tracking-[0.15em] text-[#D5AD57]">
                                        Monitor
                                    </span>

                                    <p className="mt-1 text-xs text-white/45">
                                        Performance
                                    </p>

                                </div>


                                {/* POINT 3 */}
                                <div className="absolute bottom-4 left-1/2 -translate-x-1/2 text-center">

                                    <span className="text-[9px] font-bold uppercase tracking-[0.15em] text-[#D5AD57]">
                                        Enhance
                                    </span>

                                    <p className="mt-1 text-xs text-white/45">
                                        Academic Quality
                                    </p>

                                </div>


                                {/* POINT 4 */}
                                <div className="absolute left-2 top-1/2 -translate-y-1/2">

                                    <span className="text-[9px] font-bold uppercase tracking-[0.15em] text-[#D5AD57]">
                                        Review
                                    </span>

                                    <p className="mt-1 text-xs text-white/45">
                                        Improvement
                                    </p>

                                </div>


                                {/* FLOATING STAT */}
                                <div className="absolute bottom-[35px] right-[-25px] min-w-[160px] bg-[#8B1E3F] p-5 text-white shadow-xl">

                                    <span className="text-[8px] font-bold uppercase tracking-[0.16em] text-[#D5AD57]">
                                        Committee
                                    </span>

                                    <strong className="mt-2 block font-['Libre_Caslon_Display',Georgia,serif] text-[42px] font-normal leading-none">
                                        17
                                    </strong>

                                    <span className="mt-2 block text-[10px] uppercase tracking-[0.1em] text-white/50">
                                        Members
                                    </span>

                                </div>

                            </div>

                        </div>

                    </div>

                </section>

                {/* IQAC OVERVIEW */}
                <section className="bg-white py-20 sm:py-24 lg:py-28">

                    <div className="mx-auto grid w-[min(1380px,calc(100%-48px))] gap-12 max-sm:w-[calc(100%-28px)] lg:grid-cols-[.68fr_1.32fr] lg:gap-20">

                        <div>

                            <Eyebrow>
                                About IQAC
                            </Eyebrow>

                            <Title
                                before="A Framework for"
                                highlight="Continuous Quality"
                                after=""
                                position="middle"
                                theme="burgundy"
                            />

                        </div>


                        <div className="lg:pt-7">

                            <p className="font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(27px,3vw,41px)] font-normal leading-[1.35] text-[#071A2F]">

                                The IQAC is meant for planning, guiding, monitoring Quality Assurance (QA) and Quality Enhancement (QE) in the academic activities of the University.

                            </p>


                            <p className="mt-7 max-w-[850px] text-[15px] leading-8 text-[#65727E]">

                                IQAC committee will make a significant and meaningful contribution in the accreditation phase of University. The prime task of the IQAC is to develop a system for conscious, consistent catalytic and continuous improvement in the overall performance of University.

                            </p>


                            {/* QUALITY PRINCIPLES */}
                            <div className="mt-10 grid gap-px bg-[#071A2F]/10 sm:grid-cols-3">

                                <div className="bg-[#F7F2E8] p-6">

                                    <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[30px] text-[#D5AD57]">
                                        01
                                    </span>

                                    <p className="mt-4 text-sm font-bold uppercase tracking-[0.1em] text-[#071A2F]">
                                        Plan
                                    </p>

                                    <p className="mt-2 text-xs leading-6 text-[#65727E]">
                                        Quality Assurance systems
                                    </p>

                                </div>


                                <div className="bg-[#EEF4F8] p-6">

                                    <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[30px] text-[#D5AD57]">
                                        02
                                    </span>

                                    <p className="mt-4 text-sm font-bold uppercase tracking-[0.1em] text-[#071A2F]">
                                        Monitor
                                    </p>

                                    <p className="mt-2 text-xs leading-6 text-[#65727E]">
                                        Academic performance
                                    </p>

                                </div>


                                <div className="bg-[#F4E8EC] p-6">

                                    <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[30px] text-[#D5AD57]">
                                        03
                                    </span>

                                    <p className="mt-4 text-sm font-bold uppercase tracking-[0.1em] text-[#071A2F]">
                                        Enhance
                                    </p>

                                    <p className="mt-2 text-xs leading-6 text-[#65727E]">
                                        Institutional quality
                                    </p>

                                </div>

                            </div>

                        </div>

                    </div>

                </section>

                {/* IQAC DIRECTOR */}
                <section className="relative bg-[#F7F2E8] py-20 sm:py-24 lg:py-28">

                    <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">

                        <div className="grid overflow-hidden bg-white lg:grid-cols-[.82fr_1.18fr]">

                            {/* IMAGE */}
                            <div className="relative min-h-[500px] overflow-hidden bg-[#071A2F] lg:min-h-[610px]">

                                <img src={iqacDirector} alt="Dr. N. Kumar Swamy - IQAC Director, ISBM University" className="absolute inset-0 h-full w-full object-cover object-top" />

                                <div className="absolute inset-0 bg-gradient-to-t from-[#071A2F]/80 via-transparent to-transparent" />

                                <div className="absolute bottom-0 left-0 right-0 p-7 text-white sm:p-9">

                                    <span className="text-[9px] font-bold uppercase tracking-[0.18em] text-[#D5AD57]">
                                        Internal Quality Assurance Cell
                                    </span>

                                    <p className="mt-3 font-['Libre_Caslon_Display',Georgia,serif] text-[28px] leading-tight">
                                        Leadership for Continuous Quality Enhancement
                                    </p>

                                </div>

                            </div>


                            {/* CONTENT */}
                            <div className="relative flex flex-col justify-center p-8 sm:p-12 lg:p-16 xl:p-20">

                                <span className="absolute right-8 top-4 font-['Libre_Caslon_Display',Georgia,serif] text-[120px] leading-none text-[#071A2F]/[0.035]">
                                    IQAC
                                </span>

                                <div className="relative">

                                    <Eyebrow>
                                        IQAC Director
                                    </Eyebrow>


                                    <h2 className="mt-6 max-w-[650px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(40px,5vw,62px)] font-normal leading-[1.02] tracking-[-0.035em] text-[#071A2F]">
                                        Dr. N. Kumar
                                        <span className="block text-[#8B1E3F]">
                                            Swamy
                                        </span>
                                    </h2>


                                    <div className="mt-7 flex items-center gap-4">

                                        <span className="h-px w-12 bg-[#D5AD57]" />

                                        <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-[#8B1E3F]">
                                            IQAC Director · ISBM University
                                        </span>

                                    </div>


                                    <p className="mt-8 max-w-[670px] text-[15px] leading-8 text-[#65727E]">
                                        The IQAC Director plays a key role in coordinating quality assurance initiatives and supporting the continuous enhancement of academic and institutional processes at ISBM University.
                                    </p>


                                    <div className="mt-10 grid gap-px bg-[#071A2F]/10 sm:grid-cols-3">

                                        <div className="bg-[#F7F2E8] p-5">

                                            <span className="text-[9px] font-bold uppercase tracking-[0.15em] text-[#8B1E3F]">
                                                Focus
                                            </span>

                                            <p className="mt-3 text-sm font-semibold text-[#071A2F]">
                                                Quality Assurance
                                            </p>

                                        </div>


                                        <div className="bg-[#F7F2E8] p-5">

                                            <span className="text-[9px] font-bold uppercase tracking-[0.15em] text-[#8B1E3F]">
                                                Approach
                                            </span>

                                            <p className="mt-3 text-sm font-semibold text-[#071A2F]">
                                                Continuous Review
                                            </p>

                                        </div>


                                        <div className="bg-[#F7F2E8] p-5">

                                            <span className="text-[9px] font-bold uppercase tracking-[0.15em] text-[#8B1E3F]">
                                                Goal
                                            </span>

                                            <p className="mt-3 text-sm font-semibold text-[#071A2F]">
                                                Quality Enhancement
                                            </p>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </section>

                {/* OBJECTIVES OF IQAC */}
                <section className="bg-white py-20 sm:py-24 lg:py-28">

                    <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">

                        <div className="grid gap-14 lg:grid-cols-[.68fr_1.32fr] lg:gap-20">

                            {/* LEFT */}
                            <div>

                                <Eyebrow>
                                    Objectives of IQAC
                                </Eyebrow>

                                <Title
                                    before="Building a Culture of"
                                    highlight="Quality Excellence"
                                    after=""
                                    position="middle"
                                    theme="burgundy"
                                />


                                <p className="mt-7 max-w-[440px] text-[15px] leading-8 text-[#65727E]">
                                    IQAC works towards creating a systematic and consistent approach to quality enhancement across the University.
                                </p>

                            </div>


                            {/* RIGHT */}
                            <div className="border-t border-[#071A2F]/15">

                                {[
                                    {
                                        number: "01",
                                        title: "Continuous Improvement",
                                        text: "To develop a system for conscious, consistent and continuous improvement in the overall academic and institutional performance of the University.",
                                    },
                                    {
                                        number: "02",
                                        title: "Quality Culture",
                                        text: "To promote a culture of quality through institutional commitment, academic responsibility and active participation.",
                                    },
                                    {
                                        number: "03",
                                        title: "Academic Excellence",
                                        text: "To support initiatives that strengthen teaching, learning, evaluation and the overall academic environment.",
                                    },
                                    {
                                        number: "04",
                                        title: "Quality Assurance",
                                        text: "To establish mechanisms that help maintain and enhance quality standards across University processes.",
                                    },
                                ].map((item) => (
                                    <div key={item.number} className="group grid gap-5 border-b border-[#071A2F]/15 py-7 sm:grid-cols-[70px_210px_1fr] sm:items-start">

                                        <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[32px] text-[#D5AD57]">
                                            {item.number}
                                        </span>

                                        <h3 className="font-['Libre_Caslon_Display',Georgia,serif] text-[23px] leading-[1.2] text-[#071A2F]">
                                            {item.title}
                                        </h3>

                                        <p className="text-[14px] leading-7 text-[#65727E]">
                                            {item.text}
                                        </p>

                                    </div>
                                ))}

                            </div>

                        </div>

                    </div>

                </section>

                {/* FUNCTIONS OF IQAC */}
                <section className="relative overflow-hidden bg-[#071A2F] py-20 text-white sm:py-24 lg:py-28">

                    <div className="pointer-events-none absolute right-[-180px] top-[-180px] h-[560px] w-[560px] rounded-full border border-white/[0.04]" />

                    <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">

                        <div className="grid gap-10 border-b border-white/10 pb-11 lg:grid-cols-[1fr_430px] lg:items-end">

                            <div>

                                <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#D5AD57]">
                                    Functions of IQAC
                                </span>

                                <h2 className="mt-5 max-w-[720px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(40px,5vw,62px)] font-normal leading-[1.05]">
                                    Turning quality objectives
                                    <span className="block text-[#D5AD57]">
                                        into institutional action.
                                    </span>
                                </h2>

                            </div>


                            <p className="text-[15px] leading-8 text-white/55">
                                IQAC facilitates planning, monitoring, documentation and quality enhancement initiatives across academic and administrative activities.
                            </p>

                        </div>


                        <div className="mt-14 grid border-l border-t border-white/10 md:grid-cols-2 lg:grid-cols-3">

                            {[
                                ["01", "Quality Parameters", "Develop and apply quality benchmarks and parameters for academic and administrative activities."],
                                ["02", "Academic Environment", "Facilitate the creation of a learner-centric environment conducive to quality education."],
                                ["03", "Feedback", "Support mechanisms for obtaining and analysing feedback from students and other stakeholders."],
                                ["04", "Documentation", "Document programmes and activities that contribute towards institutional quality improvement."],
                                ["05", "Quality Practices", "Promote the adoption and dissemination of effective institutional and academic practices."],
                                ["06", "Quality Coordination", "Coordinate quality-related activities and encourage continuous institutional improvement."],
                            ].map(([number, title, text]) => (
                                <article key={number} className="min-h-[245px] border-b border-r border-white/10 p-7 lg:p-8">

                                    <div className="flex items-center justify-between">

                                        <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[29px] text-[#D5AD57]">
                                            {number}
                                        </span>

                                        <span className="h-2 w-2 rotate-45 bg-[#8B1E3F]" />

                                    </div>

                                    <h3 className="mt-8 font-['Libre_Caslon_Display',Georgia,serif] text-[25px] leading-[1.15]">
                                        {title}
                                    </h3>

                                    <p className="mt-4 text-[13px] leading-7 text-white/50">
                                        {text}
                                    </p>

                                </article>
                            ))}

                        </div>

                    </div>

                </section>

                {/* STRATEGIES OF IQAC */}
                <section className="bg-[#F7F2E8] py-20 sm:py-24 lg:py-28">

                    <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">

                        <div className="text-center">

                            <Eyebrow>
                                Strategies of IQAC
                            </Eyebrow>

                            <div className="mx-auto max-w-[780px]">
                                <Title
                                    before="A Systematic Path to"
                                    highlight="Quality Enhancement"
                                    after=""
                                    position="middle"
                                    theme="burgundy"
                                />
                            </div>

                        </div>


                        <div className="relative mt-16">

                            <div className="absolute left-[10%] right-[10%] top-10 hidden h-px bg-[#D5AD57]/50 lg:block" />


                            <div className="relative grid gap-5 sm:grid-cols-2 lg:grid-cols-5">

                                {[
                                    ["01", "Plan", "Identify institutional priorities and establish quality objectives."],
                                    ["02", "Implement", "Translate quality plans into academic and administrative practices."],
                                    ["03", "Monitor", "Review performance and assess the effectiveness of quality initiatives."],
                                    ["04", "Evaluate", "Analyse outcomes, feedback and institutional performance."],
                                    ["05", "Enhance", "Use findings to support continuous and sustainable improvement."],
                                ].map(([number, title, text]) => (
                                    <article key={number} className="relative">

                                        <div className="relative z-10 mx-auto grid h-20 w-20 place-items-center rounded-full border border-[#D5AD57] bg-[#F7F2E8] font-['Libre_Caslon_Display',Georgia,serif] text-[25px] text-[#8B1E3F]">
                                            {number}
                                        </div>

                                        <div className="mt-7 text-center">

                                            <h3 className="font-['Libre_Caslon_Display',Georgia,serif] text-[26px] text-[#071A2F]">
                                                {title}
                                            </h3>

                                            <p className="mx-auto mt-3 max-w-[230px] text-[13px] leading-7 text-[#65727E]">
                                                {text}
                                            </p>

                                        </div>

                                    </article>
                                ))}

                            </div>

                        </div>

                    </div>

                </section>

                {/* BENEFITS OF IQAC */}
                <section className="bg-white py-20 sm:py-24 lg:py-28">

                    <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">

                        <div className="grid gap-12 lg:grid-cols-[.72fr_1.28fr] lg:gap-20">

                            {/* LEFT */}
                            <div>

                                <Eyebrow>
                                    Benefits of IQAC
                                </Eyebrow>

                                <Title
                                    before="Quality That Creates"
                                    highlight="Lasting Impact"
                                    after=""
                                    position="middle"
                                    theme="burgundy"
                                />


                                <div className="mt-10 border-l-[3px] border-[#D5AD57] pl-6">

                                    <p className="font-['Libre_Caslon_Display',Georgia,serif] text-[24px] leading-[1.4] text-[#071A2F]">
                                        A strong internal quality system helps the University move from periodic assessment to continuous institutional improvement.
                                    </p>

                                </div>

                            </div>


                            {/* RIGHT */}
                            <div className="grid gap-px bg-[#071A2F]/10 sm:grid-cols-2">

                                {[
                                    ["01", "Institutional Clarity", "Provides a focused approach towards quality enhancement and institutional development."],
                                    ["02", "Better Academic Practices", "Encourages continuous improvement in teaching, learning and academic processes."],
                                    ["03", "Stakeholder Confidence", "Strengthens transparency, participation and confidence among institutional stakeholders."],
                                    ["04", "Continuous Evaluation", "Creates mechanisms for regular review of academic and administrative performance."],
                                    ["05", "Quality Culture", "Promotes shared responsibility for quality across departments and institutional functions."],
                                    ["06", "Accreditation Readiness", "Supports systematic documentation and quality processes relevant to institutional assessment and accreditation."],
                                ].map(([number, title, text], index) => (
                                    <article key={number} className={`min-h-[230px] p-7 lg:p-8 ${index === 0 || index === 5 ? "bg-[#071A2F] text-white" : "bg-[#F7F2E8] text-[#071A2F]"}`}>

                                        <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[27px] text-[#D5AD57]">
                                            {number}
                                        </span>

                                        <h3 className="mt-7 font-['Libre_Caslon_Display',Georgia,serif] text-[25px] leading-[1.15]">
                                            {title}
                                        </h3>

                                        <p className={`mt-4 text-[13px] leading-7 ${index === 0 || index === 5 ? "text-white/50" : "text-[#65727E]"}`}>
                                            {text}
                                        </p>

                                    </article>
                                ))}

                            </div>

                        </div>

                    </div>

                </section>

                {/* IQAC MEETING ARCHIVE */}
                <section className="bg-[#F7F2E8] py-20 sm:py-24 lg:py-28">

                    <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">

                        {/* HEADER */}
                        <div className="grid gap-10 border-b border-[#071A2F]/15 pb-11 lg:grid-cols-[1fr_420px] lg:items-end">

                            <div>

                                <Eyebrow>
                                    IQAC Meeting Details
                                </Eyebrow>

                                <Title
                                    before="Quality Decisions,"
                                    highlight="Documented"
                                    after=""
                                    position="middle"
                                    theme="burgundy"
                                />

                            </div>


                            <p className="text-[15px] leading-8 text-[#65727E]">
                                Access IQAC meeting circulars and minutes of meetings across successive academic years.
                            </p>

                        </div>

                        {iqacMeetings.map((meeting) => (

                            <article key={meeting.number} className="grid gap-6 border-b border-[#071A2F]/15 py-8 lg:grid-cols-[90px_210px_1fr] lg:items-center">

                                {/* NUMBER */}
                                <div>

                                    <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[42px] font-normal leading-none text-[#D5AD57]">
                                        {meeting.number}
                                    </span>

                                </div>


                                {/* MEETING */}
                                <div>

                                    <span className="text-[9px] font-bold uppercase tracking-[0.16em] text-[#8B1E3F]">
                                        {meeting.year}
                                    </span>

                                    <h3 className="mt-2 font-['Libre_Caslon_Display',Georgia,serif] text-[25px] font-normal text-[#071A2F]">
                                        {meeting.meeting}
                                    </h3>

                                </div>


                                {/* DOCUMENTS */}
                                <div className="grid gap-3 sm:grid-cols-2">

                                    {/* MOM */}
                                    <a href={meeting.mom.file} target="_blank" rel="noopener noreferrer" download className="group flex min-h-[88px] items-center gap-4 border border-[#071A2F]/10 bg-white px-5 py-4 transition hover:border-[#8B1E3F]">

                                        <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-[#EEF4F8] text-[#8B1E3F]">
                                            <DocumentIcon />
                                        </span>

                                        <div className="min-w-0 flex-1">

                                            <span className="text-[8px] font-bold uppercase tracking-[0.15em] text-[#8B1E3F]">
                                                Minutes of Meeting
                                            </span>

                                            <p className="mt-1 truncate text-[12px] font-semibold text-[#071A2F]">
                                                {meeting.mom.name}
                                            </p>

                                        </div>

                                        <span className="text-[#8B1E3F] transition group-hover:translate-x-1 group-hover:-translate-y-1">
                                            <ArrowUpRight />
                                        </span>

                                    </a>


                                    {/* CIRCULAR */}
                                    <a href={meeting.circular.file} target="_blank" rel="noopener noreferrer" download className="group flex min-h-[88px] items-center gap-4 border border-[#071A2F]/10 bg-white px-5 py-4 transition hover:border-[#8B1E3F]">

                                        <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-[#F4E8EC] text-[#8B1E3F]">
                                            <DocumentIcon />
                                        </span>

                                        <div className="min-w-0 flex-1">

                                            <span className="text-[8px] font-bold uppercase tracking-[0.15em] text-[#8B1E3F]">
                                                Meeting Circular
                                            </span>

                                            <p className="mt-1 truncate text-[12px] font-semibold text-[#071A2F]">
                                                {meeting.circular.name}
                                            </p>

                                        </div>

                                        <span className="text-[#8B1E3F] transition group-hover:translate-x-1 group-hover:-translate-y-1">
                                            <ArrowUpRight />
                                        </span>

                                    </a>

                                </div>

                            </article>

                        ))}

                    </div>

                </section>

                {/* IQAC MEMBERS */}
                <section className="bg-white py-20 sm:py-24 lg:py-28">

                    <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">

                        {/* HEADER */}
                        <div className="grid gap-10 border-b border-[#071A2F]/15 pb-11 lg:grid-cols-[1fr_auto] lg:items-end">

                            <div>

                                <Eyebrow>
                                    IQAC Committee
                                </Eyebrow>

                                <Title
                                    before="The People Behind"
                                    highlight="Quality Assurance"
                                    after=""
                                    position="middle"
                                    theme="burgundy"
                                />

                            </div>


                            <div className="flex items-end gap-4">

                                <strong className="font-['Libre_Caslon_Display',Georgia,serif] text-[64px] font-normal leading-none text-[#D5AD57]">
                                    17
                                </strong>

                                <span className="pb-2 text-[10px] font-bold uppercase leading-5 tracking-[0.15em] text-[#071A2F]/50">
                                    Committee
                                    <br />
                                    Members
                                </span>

                            </div>

                        </div>


                        {/* LEADERSHIP */}
                        <div className="mt-14 grid gap-5 lg:grid-cols-3">

                            {iqacMembers.slice(0, 2).map((member, index) => (

                                <article key={member.name} className={`relative overflow-hidden p-8 text-white lg:p-9 ${index === 0 ? "bg-[#071A2F] lg:col-span-2" : "bg-[#8B1E3F]"}`}>

                                    <span className="absolute right-5 top-0 font-['Libre_Caslon_Display',Georgia,serif] text-[110px] leading-none text-white/[0.05]">
                                        {String(index + 1).padStart(2, "0")}
                                    </span>

                                    <div className="relative">

                                        <span className="text-[9px] font-bold uppercase tracking-[0.16em] text-[#D5AD57]">
                                            {member.designation}
                                        </span>

                                        <h3 className="mt-7 font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(30px,3vw,42px)] font-normal leading-[1.1]">
                                            {member.name}
                                        </h3>

                                        <p className="mt-4 text-sm text-white/55">
                                            {member.remarks}
                                        </p>

                                    </div>

                                </article>

                            ))}

                        </div>


                        {/* MEMBER DIRECTORY */}
                        <div className="mt-8 border-t border-[#071A2F]/15">

                            {iqacMembers.slice(2).map((member, index) => (

                                <article key={member.name} className="grid gap-4 border-b border-[#071A2F]/10 py-5 sm:grid-cols-[60px_1.1fr_1fr_.8fr] sm:items-center">

                                    <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[20px] text-[#D5AD57]">
                                        {String(index + 3).padStart(2, "0")}
                                    </span>


                                    <h3 className="font-['Libre_Caslon_Display',Georgia,serif] text-[20px] font-normal text-[#071A2F]">
                                        {member.name}
                                    </h3>


                                    <span className="text-[12px] font-semibold text-[#8B1E3F]">
                                        {member.designation}
                                    </span>


                                    <span className="text-[12px] leading-6 text-[#65727E]">
                                        {member.remarks}
                                    </span>

                                </article>

                            ))}

                        </div>

                    </div>

                </section>

            </main>

            <Footer />
        </>
    );
}